import { render } from "./BedrockHolder.vue?vue&type=template&id=0ae67952&ts=true"
import script from "./BedrockHolder.vue?vue&type=script&lang=ts"
export * from "./BedrockHolder.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__